// TODO: Lodash should no longer be used here
// eslint-disable-next-line no-restricted-imports
import { isEmpty } from 'lodash';
import { firebaseConfig, wsConfig } from '../api/firebase/config';

const CCMS_APP_URL = import.meta.env.VITE_WS_CCMS_APP_URL;
const GIT_SHA = import.meta.env.VITE_GIT_SHA;
const IS_TEST = import.meta.env.VITE_IS_TEST;
const FIREBASE_EMULATOR = import.meta.env.VITE_FIREBASE_EMULATOR;
const ENV_KEY = 'envName';

const LOCAL = 'local';
const DEV = 'dev';
const STAGING = 'staging';
const PROD = 'prod';

/**
 * Tries to detect the environment from config
 * @returns {'local' | 'dev' | 'staging' | 'prod' | undefined}
 */
const getEnvFromConfig = () => {
  return wsConfig?.[ENV_KEY] || undefined;
};

let savedEnv;
/**
 * Either uses a memoized env value,
 * the config-specified env value,
 * or the detected env value
 * @returns {'local' | 'dev' | 'staging' | 'prod'}
 * If not a proper env, fails fast and loud and throws an error
 */
export const getEnv = () => {
  const wasEnvSet = !!savedEnv;
  savedEnv = savedEnv || getEnvFromConfig();
  if (!wasEnvSet) {
    if (!isTest()) {
      if (isLocal()) {
        console.log('💻 LOCAL environment 💻');
      } else if (isDev()) {
        console.log('🪵 DEV environment 🪵');
      } else if (isStaging()) {
        console.log('🌲 STAGING environment 🌲');
      }
    }
  }
  if (!savedEnv || ![LOCAL, DEV, STAGING, PROD].includes(savedEnv)) {
    throw new Error('Invalid env');
  }
  return savedEnv;
};

export const getTitlePrefix = (env = getEnv()) => {
  if (isLocal(env)) {
    return '💻 ';
  } else if (isDev(env)) {
    return '🪵 ';
  } else if (isStaging(env)) {
    return '🌲 ';
  } else {
    return '';
  }
};

/**
 * gets the hosted domain name for this app
 * @returns {string}
 */
export const getDomainName = () => {
  if (getEnv() === LOCAL) {
    return '//localhost:3000';
  } else if (isDev()) {
    const currentUrl = window.location.origin;
    const previewAppRegex = /^https:\/\/moxit-wonderschool-dev--pr\d+-.*\.web\.app/;
    if (previewAppRegex.test(currentUrl)) {
      return currentUrl;
    }
  }
  return CCMS_APP_URL;
};

export const getConfig = () => {
  return {
    firebaseConfig,
    wsConfig: {
      ...wsConfig,
      domainName: getDomainName(),
    },
  };
};

/**
 * @param {string} env env name
 * @returns {boolean}
 */
export const isLocal = (env = getEnv()) => env === LOCAL;
/**
 * @param {string} env env name
 * @returns {boolean}
 */
export const isDev = (env = getEnv()) => env === DEV;
/**
 * @param {string} env env name
 * @returns {boolean}
 */
export const isStaging = (env = getEnv()) => env === STAGING;
/**
 * @param {string} env env name
 * @returns {boolean}
 */
export const isProd = (env = getEnv()) => env === PROD;
/**
 * @param {string} env env name
 * @returns {boolean}
 */
export const isTest = (env = getEnv()) => (isLocal(env) && isEmpty(GIT_SHA)) || !!IS_TEST;

/**
 * whether the emulation env variable has been set
 * @returns {boolean}
 */
export const shouldEmulateFirebase = () => FIREBASE_EMULATOR === 'ACTIVE';

// this logger needs to be independent of rollbar logger to prevent ciruclar reference
export const setupLogger = (...args) => {
  if (isLocal() && !isTest()) {
    console.log(...args);
  }
};
